import {
    Flex,
    Radio,
    RadioGroup,
    Text
} from "@chakra-ui/react";
import { useCreditCard } from "@/hooks/useCreditCard";
import { useState } from "react";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { Button, Modal } from "barte-design-system";

interface ConfigCreditCardProps {
    isOpen: boolean;
    onClose: ()=> void;
}
export default function ConfigCreditCard({ isOpen, onClose }: ConfigCreditCardProps) {
    const dueDateOptions = [12, 18, 22];
    const [selectedDay, setSelectedDay] = useState<number>(12);
    const { patchDueDateCreditCardInvoice } = useCreditCard();
    const { execute, loading } = useAsyncFunction(patchDueDateCreditCardInvoice);

    async function onSubmit() {
        try {
            await execute(selectedDay);
        } catch (error) {
        } finally {
            onClose();
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Data de vencimento"
            onClose={onClose}
            footer={{
                primaryButton: {
                    children: "Alterar data de vencimento",
                    onClick: onSubmit,
                    loading,
                    disabled: loading,
                },
                secondaryButton: { children: "Cancelar", onClick: onClose, variant: "outline", disabled: loading },
            }}
        >
            <Flex flexDirection="column" gap="2">
                <Text>Selecione a data de vencimento do seu cartão</Text>
                <RadioGroup
                    value={String(selectedDay)}
                    onChange={(nextValue: string) => setSelectedDay(Number(nextValue))}
                    border="1px solid"
                    borderColor="gray.100"
                    borderRadius="8px"
                >
                    <Flex flexDir="column">
                        {dueDateOptions.map((day, index) => (
                            <Flex
                                key={day}
                                borderBottom={index === (dueDateOptions.length - 1) ? "none" : "1px solid"}
                                borderColor="gray.100"
                                p="16px"
                                align="center"
                            >
                                <Radio value={day.toString()} colorScheme="pink">
                                    todo dia <strong>{day}</strong>
                                </Radio>
                            </Flex>
                        ))}
                    </Flex>
                </RadioGroup>
                <Text>Essa data não poderá ser alterada</Text>
            </Flex>
        </Modal>
    );
}
